function buttonRedirect(){
  var boldOptions = document.querySelector('.bold_option_set');
  var buttonContainer = document.querySelectorAll('.bold_option_checkbox');
  var productTitle = document.querySelector('.product-title');
  if (productTitle.innerText.includes('Vinyl Garment Bag - 24" x 54"')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/pvc-garment-bag-24-x54-custom-print-100-pcs-box?_pos=12&_sid=350c948eb&_ss=r';
      }, false);
    }
  });
  }
  if (productTitle.innerText.includes('Vinyl Garment Bag - 24" x 66"')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/copy-of-pvc-garment-bag-24-x-66-custom-print-100-pcs-box?_pos=8&_sid=50a443c9d&_ss=r';
      }, false);
    }
  });
  }
  if (productTitle.innerText.includes('Vinyl Garment Bag - 24" x 72"')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/pvc-garment-bag-24-x-72-custom-print-100-pcs-box?_pos=9&_sid=50a443c9d&_ss=r';
      }, false);
    }
  });
  }
  if (productTitle.innerText.includes('Vinyl Garment Bag - 24" x 72" x 10"')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/pvc-garment-bag-24-x-72-x-10-custom-print-50-pcs-box?_pos=15&_sid=50a443c9d&_ss=r';
      }, false);
    }
  });
  }
  if (productTitle.innerText.includes('Vinyl Garment Bag - 24" x 72" x 12"')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/copy-of-pvc-garment-bag-24-x-72-x-10-custom-print-50-pcs-box?_pos=14&_sid=50a443c9d&_ss=r';
      }, false);
    }
  });
  }
  if (productTitle.innerText.includes('Vinyl Garment Bag - 24" x 72" x 20"')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/pvc-garment-bag-24-x-72-x-20-custom-print-50-pcs-box?_pos=13&_sid=50a443c9d&_ss=r';
      }, false);
    }
  });
  }
  if (productTitle.innerText.includes('Non-Woven Garment Bag - 24" x 40/42" x 3"')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/non-woven-garment-bag-24-x-40-42-x-3-custom-print-50-pcs-box?_pos=17&_sid=50a443c9d&_ss=r';
      }, false);
    }
  });
  }
  if (productTitle.innerText.includes('Non-Woven Garment Bag - 24" x 54" x 3"')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/non-woven-garment-bag-24-x-54-x-3-custom-print-50-pcs-box?_pos=16&_sid=50a443c9d&_ss=r';
      }, false);
    }
  });
  }
  if (productTitle.innerText.includes('Non-Woven Garment Bag - 24" x 72" + Gusset')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/non-woven-garment-bag-24-x-72-x-3-10?_pos=12&_sid=50a443c9d&_ss=r';
      }, false);
    }
  });
  }
  if (productTitle.innerText.includes('Vinyl Garment Bag - 24" x 40"')){
    buttonContainer.forEach((element) => {
    var button = element.querySelector('.bold_option_title');
    if (button && button.innerText.includes('Order Custom Printed Bags')) {
      button.parentElement.addEventListener('click', function(e) {
        window.location.href = 'https://zipperandthread.com/products/pvc-garment-bag-24-x40-custom-print?_pos=2&_sid=efcbe04d5&_ss=r';
      }, false);
    }
  });
  }
}
